import { ListingActionTypes } from '@state/features/common.types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
const NewBreadcrumb = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { breadcrumbs } = useSelector((state) => state.search);
    const baseUrl = location.origin;
    let breadcrumbsList = [...breadcrumbs];
    breadcrumbsList.pop();
    return (React.createElement(React.Fragment, null,
        React.createElement("nav", { "aria-label": t('navigation.breadcrumb.aria'), className: "breadcrumb listing" },
            React.createElement("ol", null, breadcrumbsList.map((item, i) => (React.createElement("li", { key: i },
                React.createElement("a", { href: `${baseUrl}${item.url}`, onClick: () => {
                        dispatch({
                            type: ListingActionTypes.FETCH_LISTING,
                            payload: {
                                cgid: item.categoryId,
                                resultsType: 'INIT',
                                start: 0,
                            },
                        });
                    }, className: "breadcrumb__item", key: item.categoryId }, item.htmlValue))))))));
};
export default NewBreadcrumb;
